<table>
  <thead>
      <th class="subtable string">{{'global.provincia' | translate}}</th>
      <th class="subtable string">{{'global.municipio' | translate}}</th>
      <th class="subtable string">{{'global.finca' | translate}}</th>
      <th class="subtable string">{{'gestionRoyalties.etiquetador.cultivos.productor' | translate}}</th>
      <th class="subtable number">{{'gestionRoyalties.etiquetador.cultivos.pesoEtiquetado' | translate}} ({{ _unidadesMedida.peso.symbol }})</th>
      <th class="subtable number">{{'gestionRoyalties.etiquetador.cultivos.importe' | translate}} ({{ _unidadesMedida.divisas.symbol }})</th>
  </thead>
  <tbody *ngFor="let cultivo of cultivosEtiquetador; let i = index;">
    <tr>
      <td class="string">{{cultivo.desProvincia}}</td>
      <td class="string">{{cultivo.desMunicipio}}</td>
      <td class="string">{{cultivo.desFinca}}</td>
      <td class="string">{{cultivo.desProductor}}</td>
      <td class="number">{{cultivo.sumaKilos | number : '1.2-2' : defaultLanguage }}</td>
      <td class="number">{{cultivo.calculo_Kilos_Fee | number : '1.2-2' : defaultLanguage}}</td>
    </tr>
  </tbody>
  <tfoot *ngIf="_cultivos && _cultivos.length < 1">
      <tr>
        <td colspan="3">
          {{'global.noContent' | translate}}
        </td>
      </tr>
  </tfoot>
</table>
<app-paginator
        *ngIf="(_cultivos && _cultivos.length > 0)"
        [itemsPerPage]="itemsPerPage" [currentPage]="currentPage" [totalItems]="totalItems"
        [visiblePages]="visiblePages" (pageChange)="pageChange($event)" [hiddeItems]="true"></app-paginator>
